import { connectFela } from '../../../../dependencies';
import ServiceNote from './ServiceNote';
import * as styles from './ServiceNote.styles';

export default connectFela(styles)(ServiceNote);
